<div class="w-full bg-white mt-1 border border-gray-300 shadow-lg">
  @for (value of data.values() || []; track value._id) {
    <button
      (click)="select(value)"
      class="p-2 text-sm w-full text-left"
      [ngClass]="{ 'bg-gray-200': selectedIndex() == $index }"
      (mouseenter)="selectedIndex.set($index)"
    >
      {{ value.displayValue }}
    </button>
  } @empty {
    @if (data.allowNewEntry()) {
      <button (click)="createNewEntry()" class="p-2 text-sm w-full text-left flex flex-row gap-1 items-center bg-gray-200">
        <ng-icon name="heroPlus" size="16px"></ng-icon>
        <span>{{ data.newEntryText() || { key: 'comboboxNewEntry', n: 1 } | i18n }}</span>
      </button>
    } @else {
      <div class="p-2 text-sm w-full text-left flex flex-row gap-1 items-center text-gray-400">
        <ng-icon name="heroNoSymbol" size="16px"></ng-icon>
        <span>{{ data.noRowsText() || { key: 'comboboxNoRowsFound', n: 1 } | i18n }}</span>
      </div>
    }
  }
</div>
